import { GraphData } from "../../interfaces/dataInterfaces"
import { IModaFetchData, IOutlierDetection, IReportObs, ObservationStatus } from "../../interfaces/markets"
import { marketpricesApi } from "./marketpricesApi"

export const commodityPriceApi = marketpricesApi.injectEndpoints({
  endpoints: builder => ({
    editOutliers: builder.mutation<
      void,
      { commodityPriceId: number; commodityPriceValue: number; commodityPriceMetadata: string }
    >({
      query: body => ({
        url: "CommodityPrices/UpdateCommodityPrice",
        method: "PUT",
        body,
      }),
      invalidatesTags: ["OutliersList"],
    }),

    deleteReportObs: builder.mutation<void, number>({
      query: id => ({
        url: "CommodityPrices/DeleteCommodityPriceObservation",
        method: "DELETE",
        params: { commodityPriceObservationId: id },
      }),
      invalidatesTags: ["ReportObs"],
    }),

    saveModaFetch: builder.mutation<void, IModaFetchData>({
      query: data => ({
        url: "CommodityPrices/SaveFetch",
        method: "POST",
        body: {
          ...data,
          endDate: data?.endDate ? new Date(data.endDate)?.toISOString() : null,
          dataCollectionEndDate: data?.dataCollectionEndDate
            ? new Date(data.dataCollectionEndDate)?.toISOString()
            : null,
          dataCollectionStartDate: data?.dataCollectionStartDate
            ? new Date(data.dataCollectionStartDate)?.toISOString()
            : null,
        },
      }),
    }),

    updateCommodityPriceObservation: builder.mutation<void, IReportObs[]>({
      query: body => ({
        url: "CommodityPrices/UpdateCommodityPriceObservations",
        method: "POST",
        body: { commodityPriceObservations: body },
      }),
      invalidatesTags: ["ReportObs"],
    }),

    getMoMYoY: builder.mutation<IOutlierDetection[], { seriesCombination: string; month: number; year: number }[]>({
      query: body => ({ url: "CommodityPrices/GetOutlierDetectionData", method: "POST", body }),
    }),

    getGraphData: builder.mutation<GraphData, any | undefined>({
      query: body => ({ url: "CommodityPrices/GetGraphData", method: "POST", body }),
    }),

    getReportObs: builder.query<IReportObs[], number>({
      query: reportId => ({
        url: "CommodityPrices/GetCommodityPriceObservations",
        method: "GET",
        params: { reportId },
      }),
      transformResponse: (response: IReportObs[]) =>
        response.map(item => {
          if (
            item.observationStatusId !== ObservationStatus.VALID &&
            item.observationStatusId !== ObservationStatus.APPROVED
          ) {
            return item
          }
          const seriesCombinationCode = `${item.marketId}-${item.commodityId}-${item.priceTypeId}-${item.commodityUnitId}-${item.currencyId}`
          return { ...item, seriesCombinationCode }
        }),
      providesTags: ["ReportObs"],
    }),
  }),
})

export const {
  useEditOutliersMutation,
  useDeleteReportObsMutation,
  useSaveModaFetchMutation,
  useUpdateCommodityPriceObservationMutation,
  useGetMoMYoYMutation,
  useGetReportObsQuery,
  useGetGraphDataMutation,
} = commodityPriceApi
